import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { MenuService } from "../../../services/MenuService";
import CustomSwitch from "../../../components/CustomSwitch";
import { CompanyService } from "../../../services/CompanyService";
import { DocumentService } from "../../../services/DocumentService";
import { AddDocumentResponse } from "../../../models/response/document/AddDocumentResponse";
import axios from "axios";
import { GetDocumentByIdResponse } from "../../../models/response/document/GetDocumentByIdResponse";
import CustomTextInput from "../../../components/CustomTextInput";

const DocumentAdd = () => {
    const navigate = useNavigate();
    const pageName = "Ayarlar > Evrak Tasarımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [documentId, setDocumentId] = useState<string | undefined>(undefined);
    const [name, setName] = useState<string | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState(true);
    const [selectedMenu, setSelectedMenu] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCompany, setSelectedCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [file, setFile] = useState<File | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetDocumentByIdResponse = await DocumentService.getDocumentById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setDocumentId(response.data.documentId);

                if (response.data.menuId)
                    setSelectedMenu({ label: response.data.menuName, value: response.data.menuId });

                setName(response.data.name);

                if (response.data.companyId)
                    setSelectedCompany({ label: response.data.companyName, value: response.data.companyId });

                setIsCustomActive(response.data.isCustomActive);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveDocument = async () => {
        try {
            if (!selectedMenu)
                toast.error('Menü alanını doldurunuz!')
            else if (!name || Helpers.isEmpty(name))
                toast.error('Evrak Adı alanını doldurunuz!')
            else if (!documentId && !file)
                toast.error('Dosya alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddDocumentResponse = await DocumentService.addDocument({
                    companyId: selectedCompany?.value,
                    documentId: documentId,
                    file: file,
                    isCustomActive: isCustomActive ? 1 : 0,
                    menuId: selectedMenu.value,
                    menuName: selectedMenu.label,
                    name: name
                });

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message);

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const downloadTemplate = async () => {
        dispatch(storeActivityIndicator(true));

        try {
            var fileName = selectedMenu?.label?.replaceAll('>', ';') + '.frx';

            const response = await axios.get((Helpers.getEndpoint() + '/Document/DownloadTemplate?fileName=' + fileName), {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const blob = new Blob([response.data], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
        } catch (error) {
            // toast.error('Bir hata oluştu: ' + error?.toString());
            toast.error('Rapor şablonu bulunamadı!');
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className='row'>
                                    <div className="col-md-4">
                                        <Box flexDirection='row'>
                                            <Box flexGrow={1} justifyContent="center">
                                                <label htmlFor="exampleFormControlInput1" className="form-label required">Menü</label>
                                            </Box>
                                            {
                                                selectedMenu && (
                                                    <Box justifyContent="center">
                                                        <label onClick={downloadTemplate} htmlFor="exampleFormControlInput1" className="actionIcon form-label text-primary"><i className="text-primary fa fa-download"></i>&nbsp;Rapor Şablonunu İndir</label>
                                                    </Box>
                                                )
                                            }
                                        </Box>


                                        <CustomSingleSelect
                                            disabled={!Helpers.isEmpty(documentId)}
                                            selectedValue={selectedMenu}
                                            onChange={setSelectedMenu}
                                            onMenuOpen={[() => MenuService.getMenuList()]}
                                            labelName='name'
                                            valueName='menuId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Evrak Adı</label>
                                        <CustomTextInput
                                            isDisabled={!Helpers.isEmpty(documentId)}
                                            value={name}
                                            setValue={setName}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Şirket</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedCompany}
                                            onChange={setSelectedCompany}
                                            onMenuOpen={[
                                                () => CompanyService.getCompanyList({ isCompany: true })
                                            ]}
                                            labelName='name'
                                            valueName='companyId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className={"form-label " + (documentId ? '' : 'required')}>Dosya</label>
                                        <input onChange={(e) => { setFile(e && e.target && e.target.files && e.target.files.length > 0 ? e.target.files[0] : undefined) }} type="file" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                        <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveDocument}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default DocumentAdd;